import axios from "axios";

import { ApiService } from "../../../../servicios/api.service";

export class AuthApi {
    static endPoint = "cliente/";

    static get BasePath() {
        return ApiService.api + this.endPoint;
    }

    static async createClient(data) {
        const response = await axios.post(this.BasePath, data);

        return response.data;
    }

    static async getClientData(dni) {
        const response = await axios.get(this.BasePath + "dni/" + dni);

        return response.data;
    }

    static async logInWithDni(dni) {
        const dto = { dni };

        const response = await axios.post(ApiService.api + 'sb/loginWithDNI', dto);

        return response.data;
    }
}